import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const betaLogo = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 1639.09 187">
    <path
      d="M350.858 35.0146L304.567 150.949H288.953L242.523 35.0146H265.565L296.829 117.129L327.92 35.0146H350.858Z"
      fill="white"
    />
    <path
      d="M345.775 110.255C345.775 88.9061 358.246 67.2461 385.986 67.2461C414.694 67.2461 423.986 90.3225 423.986 108.701C424.061 111.347 423.805 113.993 423.226 116.577H366.952C368.679 127.355 374.586 134.575 387.472 134.575C395.012 134.791 402.248 131.593 407.163 125.87L420.981 137.926C412.551 147.652 400.199 153.079 387.334 152.712C359.075 152.608 345.775 132.226 345.775 110.255ZM404.261 102.033C404.309 100.294 404.088 98.5577 403.604 96.8861C401.566 88.4225 394.519 84.0697 385.814 84.0697C373.999 84.0697 368.817 91.7734 366.952 102.033H404.261Z"
      fill="white"
    />
    <path
      d="M440.709 68.9722H460.262V82.7904C463.566 73.4921 472.365 67.2801 482.233 67.2795C487.826 67.1829 493.23 69.3071 497.26 73.1868L488.14 89.5959C485.503 87.7924 482.387 86.818 479.193 86.7977C469.831 86.7977 460.089 95.5032 460.089 116.369V150.914H440.709V68.9722Z"
      fill="white"
    />
    <path
      d="M517.831 27.2119L532.939 41.8023L518.349 56.911L503.24 42.3207L517.831 27.2119ZM508.072 68.9724H528.108V150.949H508.072V68.9724Z"
      fill="white"
    />
    <path
      d="M556.746 85.7281H541.719V68.9735H556.919V57.9881C556.919 42.0626 569.321 33.2881 583.104 33.2881C588.243 33.3874 593.304 34.5643 597.959 36.7426L591.395 53.2554C589.474 52.0087 587.257 51.2935 584.97 51.1826C580.962 51.1826 577.439 53.739 577.439 60.1299V69.0772H596.542V85.8317H577.473V151.054H556.746V85.7281Z"
      fill="white"
    />
    <path
      d="M632.161 148.739L600.068 68.9736H622.074L642.801 125.939L663.805 68.9736H685.776L638.932 186.255H617.099L632.161 148.739Z"
      fill="white"
    />
    <path
      d="M186.834 93.417L93.417 186.835L0 93.417L93.417 0L186.834 93.417ZM44.5225 93.417L93.416 142.312L142.311 93.417L93.416 44.5234L44.5225 93.417Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="url(#paint0_linear_beta)"
    />
    <g filter="url(#filter0_beta)">
      <rect
        x="22.6289"
        y="115.897"
        width="30.8511"
        height="31.7414"
        transform="rotate(-45 22.6289 115.897)"
        fill="#EA3632"
      />
    </g>
    <g filter="url(#filter1_beta)">
      <rect
        x="142.459"
        y="93.8301"
        width="31.3673"
        height="31.129"
        transform="rotate(-45 142.459 93.8301)"
        fill="#EA3632"
      />
    </g>
    <path
      d="M187 93.613L164.765 71.378L93.6126 142.53L44.6956 93.613L22.4605 115.848L93.6126 187L187 93.613Z"
      fill="#EA3632"
    />
    <path
      d="M765.506 152.389C731.639 152.389 713.543 127.984 713.543 92.374C713.543 56.5977 731.722 32.7744 766.419 32.7744C789.578 32.7744 804.769 43.0674 812.986 63.8193L805.267 66.8906C798.958 48.6289 786.341 40.5771 766.336 40.5771C736.868 40.5771 721.678 60.333 721.678 92.042C721.678 121.593 734.627 144.503 765.506 144.503C785.013 144.503 797.796 135.953 805.516 117.94L813.152 121.012C804.021 141.598 788.167 152.389 765.506 152.389Z"
      fill="white"
    />
    <path
      d="M863.956 152.389C840.963 152.389 824.694 133.629 824.694 109.557C824.694 85.8164 840.963 67.1396 863.956 67.1396C886.867 67.1396 903.468 85.8164 903.468 109.557C903.468 133.463 886.867 152.389 863.956 152.389ZM863.956 145.416C882.882 145.416 895.333 129.562 895.333 109.557C895.333 89.7178 882.882 74.1123 863.956 74.1123C845.114 74.1123 832.912 89.6348 832.912 109.557C832.912 129.645 845.114 145.416 863.956 145.416Z"
      fill="white"
    />
    <path
      d="M924.638 151.227L924.555 68.3018H932.275V84.0732C936.592 72.9502 946.054 67.1396 958.091 67.1396C971.206 67.1396 980.669 73.4482 984.072 86.7295C988.305 74.1123 998.598 67.1396 1011.71 67.1396C1031.22 67.1396 1039.85 80.7529 1039.85 103.248V151.227H1031.97V104.078C1031.97 84.5713 1025.66 74.5273 1010.3 74.5273C995.61 74.5273 986.23 85.3184 986.23 100.924V151.227H978.345V100.26C978.345 83.9902 971.372 74.5273 956.762 74.5273C941.904 74.5273 932.524 85.3184 932.524 100.924V151.227H924.638Z"
      fill="white"
    />
    <path
      d="M1066.17 185.592V68.3018H1074.22V89.9668C1079.2 76.0215 1091.49 67.1396 1106.01 67.1396C1128.09 67.1396 1140.96 86.1484 1140.96 109.889C1140.96 133.546 1128.09 152.389 1105.93 152.389C1091.32 152.389 1079.2 143.424 1074.22 129.645V185.592H1066.17ZM1104.35 145.084C1122.78 145.084 1133.07 129.728 1133.07 109.889C1133.07 89.8838 1122.78 74.5273 1104.35 74.5273C1085.93 74.5273 1073.64 89.7178 1073.64 109.889C1073.64 129.894 1085.93 145.084 1104.35 145.084Z"
      fill="white"
    />
    <path
      d="M1189.94 67.1396C1210.69 67.1396 1222.06 79.4248 1222.06 100.426V151.227H1215.34L1214.84 132.55C1208.2 145.665 1196.58 152.389 1183.3 152.389C1166.53 152.389 1155.16 143.092 1155.16 127.652C1155.16 111.217 1168.11 103.995 1190.52 103.995H1214.76V101.754C1214.76 83.2432 1207.29 74.1953 1189.94 74.1953C1178.4 74.1953 1170.85 79.0098 1164.45 88.3066L1158.4 83.8242C1166.45 72.6182 1175.74 67.1396 1189.94 67.1396ZM1184.63 145.499C1199.48 145.499 1209.61 136.617 1214.76 122.008V110.055H1190.85C1172.17 110.055 1163.21 116.363 1163.21 127.901C1163.21 138.609 1171.1 145.499 1184.63 145.499Z"
      fill="white"
    />
    <path
      d="M1248.05 151.227V68.3018H1255.77V86.8125C1260.17 73.1162 1272.37 67.1396 1282.5 67.1396C1286.81 67.1396 1291.21 68.2188 1294.7 70.46L1291.04 77.0176C1288.06 75.6064 1284.82 74.8594 1281.5 74.8594C1269.88 74.8594 1255.77 83.4922 1255.77 106.485V151.227H1248.05Z"
      fill="white"
    />
    <path
      d="M1334.71 152.389C1310.89 152.389 1297.11 134.542 1297.11 110.221C1297.11 86.1484 1310.47 67.1396 1333.3 67.1396C1359.78 67.1396 1368.41 88.6387 1368.41 104.327C1368.41 106.9 1368.25 110.221 1367.91 111.466H1305.41C1305.91 132.55 1316.78 145.084 1334.71 145.084C1345.5 145.084 1352.47 142.262 1360.53 133.961L1366.09 139.024C1356.62 148.57 1347.83 152.389 1334.71 152.389ZM1305.41 105.489H1360.44C1360.61 103.829 1360.61 101.92 1360.44 100.343C1359.78 88.2236 1352.31 73.9463 1333.22 73.9463C1317.03 73.9463 1306.65 86.8125 1305.41 105.489Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_beta"
        x="13.6446"
        y="85.0977"
        width="53.2441"
        height="53.2441"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-4.49215" dy="-4.49215" />
        <feGaussianBlur stdDeviation="2.24608" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_beta" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_beta" result="shape" />
      </filter>
      <filter
        id="filter1_beta"
        x="133.475"
        y="62.6661"
        width="53.1757"
        height="53.1757"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-4.49215" dy="-4.49215" />
        <feGaussianBlur stdDeviation="2.24608" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_beta" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_beta" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_beta"
        x1="46.7083"
        y1="0.226562"
        x2="46.7083"
        y2="144.227"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EA3632" />
        <stop offset="1" stopColor="#800E0C" />
      </linearGradient>
    </defs>
    <g transform="translate(692.40 0) scale(5.84375)">
      <rect
        x="125"
        y="8"
        width="30"
        height="17"
        rx="3"
        fill="var(--gds-color-cool-gray-700, #1F2126)"
        stroke="#36373C"
      />
      <path
        d="M130.844 12.5752H132.755C133.584 12.5752 134.21 12.6953 134.632 12.9355C135.054 13.1758 135.265 13.5903 135.265 14.1792C135.265 14.4253 135.221 14.6479 135.133 14.8472C135.048 15.0435 134.923 15.2061 134.759 15.335C134.595 15.4609 134.393 15.5459 134.153 15.5898V15.6338C134.402 15.6777 134.623 15.7554 134.816 15.8667C135.013 15.978 135.167 16.1377 135.278 16.3457C135.392 16.5537 135.449 16.8232 135.449 17.1543C135.449 17.5469 135.355 17.8809 135.168 18.1562C134.983 18.4316 134.718 18.6411 134.373 18.7847C134.03 18.9282 133.623 19 133.151 19H130.844V12.5752ZM131.898 15.2251H132.909C133.387 15.2251 133.718 15.1475 133.902 14.9922C134.087 14.8369 134.179 14.6099 134.179 14.311C134.179 14.0063 134.069 13.7866 133.85 13.6519C133.633 13.5171 133.287 13.4497 132.812 13.4497H131.898V15.2251ZM131.898 16.0776V18.1167H133.01C133.502 18.1167 133.848 18.0215 134.047 17.8311C134.247 17.6406 134.346 17.3828 134.346 17.0576C134.346 16.8584 134.301 16.6855 134.21 16.5391C134.122 16.3926 133.977 16.2798 133.775 16.2007C133.573 16.1187 133.3 16.0776 132.958 16.0776H131.898ZM138.609 14.043C139.042 14.043 139.415 14.1323 139.725 14.311C140.036 14.4897 140.274 14.7432 140.441 15.0713C140.608 15.3994 140.692 15.792 140.692 16.249V16.8027H137.444C137.456 17.2744 137.582 17.6377 137.822 17.8926C138.065 18.1475 138.405 18.2749 138.842 18.2749C139.152 18.2749 139.431 18.2456 139.677 18.187C139.926 18.1255 140.182 18.0361 140.446 17.9189V18.7583C140.203 18.8726 139.955 18.9561 139.703 19.0088C139.451 19.0615 139.149 19.0879 138.798 19.0879C138.32 19.0879 137.9 18.9956 137.537 18.811C137.176 18.6235 136.894 18.3452 136.688 17.9761C136.486 17.6069 136.385 17.1484 136.385 16.6006C136.385 16.0557 136.478 15.5928 136.662 15.2119C136.847 14.8311 137.106 14.541 137.44 14.3418C137.774 14.1426 138.164 14.043 138.609 14.043ZM138.609 14.8208C138.284 14.8208 138.02 14.9263 137.818 15.1372C137.619 15.3481 137.501 15.6572 137.466 16.0645H139.681C139.678 15.8213 139.637 15.606 139.558 15.4185C139.482 15.231 139.365 15.0845 139.207 14.979C139.051 14.8735 138.852 14.8208 138.609 14.8208ZM143.667 18.2529C143.802 18.2529 143.935 18.2412 144.067 18.2178C144.199 18.1914 144.319 18.1606 144.427 18.1255V18.9077C144.313 18.9575 144.165 19 143.983 19.0352C143.802 19.0703 143.613 19.0879 143.417 19.0879C143.141 19.0879 142.894 19.0425 142.674 18.9517C142.454 18.8579 142.28 18.6982 142.151 18.4727C142.022 18.2471 141.958 17.9351 141.958 17.5366V14.9219H141.294V14.4604L142.006 14.0957L142.344 13.0542H142.995V14.1353H144.388V14.9219H142.995V17.5234C142.995 17.7695 143.056 17.9526 143.179 18.0728C143.302 18.1929 143.465 18.2529 143.667 18.2529ZM147.323 14.043C147.938 14.043 148.403 14.1792 148.716 14.4517C149.033 14.7241 149.191 15.1489 149.191 15.7261V19H148.457L148.259 18.3101H148.224C148.086 18.4858 147.944 18.6309 147.798 18.7451C147.651 18.8594 147.481 18.9443 147.288 19C147.098 19.0586 146.865 19.0879 146.589 19.0879C146.299 19.0879 146.04 19.0352 145.812 18.9297C145.583 18.8213 145.403 18.6572 145.271 18.4375C145.139 18.2178 145.073 17.9395 145.073 17.6025C145.073 17.1016 145.259 16.7251 145.631 16.4731C146.006 16.2212 146.572 16.082 147.328 16.0557L148.171 16.0249V15.77C148.171 15.4331 148.092 15.1929 147.934 15.0493C147.779 14.9058 147.559 14.834 147.275 14.834C147.032 14.834 146.796 14.8691 146.567 14.9395C146.339 15.0098 146.116 15.0962 145.899 15.1987L145.565 14.4692C145.803 14.3433 146.072 14.2407 146.374 14.1616C146.679 14.0825 146.995 14.043 147.323 14.043ZM148.167 16.6753L147.539 16.6973C147.023 16.7148 146.661 16.8027 146.453 16.9609C146.245 17.1191 146.141 17.3359 146.141 17.6113C146.141 17.8516 146.213 18.0273 146.356 18.1387C146.5 18.2471 146.689 18.3013 146.923 18.3013C147.281 18.3013 147.577 18.2002 147.811 17.998C148.048 17.793 148.167 17.4927 148.167 17.0972V16.6753Z"
        fill="white"
        fillOpacity="0.87"
      />
    </g>
  </SvgIcon>
);
